import $ from 'jquery'
import {Feature, isEnabled} from '../../../features'
import {ReportColumnsFormatCostOfWork} from 'constants'
import {ReportGroupingLevel} from '../../constants'
import CostReportEditConfigController from './CostReportEditConfigController'

export default class CostReportEditFormConfigController extends CostReportEditConfigController {}

CostReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function ( reportParameters ) {
    const result = $.extend({}, reportParameters);
    if ( !isEnabled(Feature.UGR) && result.columnsConfig !== ReportColumnsFormatCostOfWork.USERS_ONLY )
        result.columnsConfig = ReportColumnsFormatCostOfWork.USERS_ONLY;

    if (!isEnabled(Feature.BTY))
    {
        const groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.BILLING_TYPE,
                                                                                  [result.firstGroupingLevel, result.secondGroupingLevel],
                                                                                  ReportGroupingLevel.CUSTOMER
        );
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }

    if( !isEnabled(Feature.LVT))
        result.showLeaveTimeCosts = false;

    if( !isEnabled(Feature.OVR))
        result.showOvertimeAddition = false;

    return result;
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/costOfWork/CostReportEditFormConfigController.js